import httpService from '../../../services/httpService';
import OnboardingFlowRepository from '../domain/onboardingFlowRepository'

export default class RemoteOnboardingFlowRepository extends OnboardingFlowRepository {
  async get() {
    return httpService.get('/onboarding/validate-workflow')
  }
}
